import React, {useEffect, useState} from 'react';
import {coy} from "react-syntax-highlighter/dist/cjs/styles/prism";
import {Prism as SyntaxHighlighter} from "react-syntax-highlighter";

const CurlExample = (props) => {
    const {method, url, data, headers, paramsType, changeCodeText, customStyle} = props;
    const [codeText, setCodeText] = useState('');

    const getParamString = () => {
        let paramsString = ``;

        const params = data;
        for(let name in params) {
            paramsString += `${name}=${params[name]}&`;
        }
        paramsString = paramsString.slice(0, -1);
        return paramsString;
    };
    const getHeadersStrings = (headers) => {
        const headersStrings = [];

        for(let key in headers) {
            const header = `${key}: ${headers[key]}`;
            headersStrings.push(`-H '${header}' \\`);
        }
        headersStrings[headersStrings.length - 1] = headersStrings[headersStrings.length - 1].slice(0, -1);
        headersStrings.push('');
        return headersStrings;
    };
    const getDataString = () => {
        const dataValue = paramsType === 'json' ? JSON.stringify(data) : getParamString();
        const dataString = method === 'post' ? `-d '${dataValue}'` :  null;
        return dataString;
    };
    useEffect(() => {
        const headersStrings = getHeadersStrings(headers);
        const dataString = getDataString();
        const codeStrings = [
            `curl ${url} \\`,
            `-X ${method.toUpperCase()} \\`,
            `${dataString} \\`,
            ...headersStrings,
        ].filter(str => str !== null);
        setCodeText(codeStrings.join('\n'));
        changeCodeText(codeText);
    });



    return (
            <div className="curl-example">
                <SyntaxHighlighter
                    language="bash"
                    style={coy}
                    wrapLines={true}
                    customStyle={customStyle}
                >
                    {codeText}
                </SyntaxHighlighter>
            </div>
    );
}


export default CurlExample;
